import React from 'react';
import PropTypes from 'prop-types';

const Radio = ({
    children,
    input: { name, value, onBlur, onChange, ...rest },
    id,
    radioValue,
    label,
    sublabel,
    className,
    labelClassName,
}) => {
    const realValue = radioValue === undefined ? id : radioValue;

    return (
        <div className={`label-container ${!!className && className}`}>
            <input
                id={id}
                name={name}
                {...rest}
                type="radio"
                className="radio"
                value={realValue}
                onClick={() => onBlur(realValue)}
                onChange={() => onChange(realValue)}
                checked={value === realValue}
            />
            <label
                htmlFor={id}
                className={`label label--radio ${!!labelClassName && labelClassName}`}
            >
                <div className="label__content">
                    <span className="margin-right-half">{label}</span>
                    {sublabel && <p className="sublabel">{sublabel}</p>}
                </div>
            </label>
            {children}
        </div>
    );
};

Radio.displayName = 'Radio';

Radio.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    input: PropTypes.shape({
        onBlur: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
        name: PropTypes.string,
    }).isRequired,
    labelClassName: PropTypes.string,
};

/**
 * Radio Functional Component.
 */
export default Radio;
